export const UPDATE_RESUME="UPDATE_RESUME"
export const UPDATE_SKILLS="UPDATE_SKILLS"
export const UPDATE_PROJECT="UPDATE_PROJECT"
export const UPDATE_DETAILS="UPDATE_DETAILS"